var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_534_1548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.485352,
    y: 0.859238,
    width: 23.6633,
    height: 23.6633,
    fill: "#212529"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_534_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6053 22.5506L9.21091 19.3955C8.99728 19.3133 8.79598 19.2147 8.607 19.0997C8.41802 18.9846 8.23315 18.8614 8.05239 18.7299L5.11913 19.9624L2.40771 15.279L4.94659 13.3564C4.93015 13.2414 4.92194 13.1304 4.92194 13.0236V12.3581C4.92194 12.2513 4.93015 12.1404 4.94659 12.0253L2.40771 10.1027L5.11913 5.41933L8.05239 6.65179C8.23315 6.52033 8.42213 6.39709 8.61933 6.28206C8.81652 6.16703 9.01371 6.06843 9.21091 5.98626L9.6053 2.83116H15.0281L15.4225 5.98626C15.6361 6.06843 15.8374 6.16703 16.0264 6.28206C16.2154 6.39709 16.4003 6.52033 16.581 6.65179L19.5143 5.41933L22.2257 10.1027L19.6868 12.0253C19.7033 12.1404 19.7115 12.2513 19.7115 12.3581V13.0236C19.7115 13.1304 19.6951 13.2414 19.6622 13.3564L22.2011 15.279L19.4896 19.9624L16.581 18.7299C16.4003 18.8614 16.2113 18.9846 16.0141 19.0997C15.8169 19.2147 15.6197 19.3133 15.4225 19.3955L15.0281 22.5506H9.6053ZM12.366 16.1418C13.3191 16.1418 14.1325 15.8049 14.8063 15.1311C15.48 14.4574 15.8169 13.644 15.8169 12.6909C15.8169 11.7378 15.48 10.9243 14.8063 10.2506C14.1325 9.57684 13.3191 9.23997 12.366 9.23997C11.3965 9.23997 10.5789 9.57684 9.91341 10.2506C9.24788 10.9243 8.91512 11.7378 8.91512 12.6909C8.91512 13.644 9.24788 14.4574 9.91341 15.1311C10.5789 15.8049 11.3965 16.1418 12.366 16.1418Z",
    fill: "#4E5154"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.fbcc493d3cfa56e666d0248d5f5d9dc7.svg";
export { ForwardRef as ReactComponent };